import { PopupReturnTypeWithPayload } from '../../../../hooks/usePopup'
import { DeleteResponseUserPayload } from '../ResponsibleForRFP/DeleteUserPopup/types'
import { TResponsibleUser } from '../types'
import { initialPopup } from '../../../../hooks/constants'

export const defaultDeleteResponsibleUserPopup: PopupReturnTypeWithPayload<DeleteResponseUserPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: { user: {} as TResponsibleUser }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }
